import VideoMeetingCreationModal from "./VideoMeetingCreationModal.js";
export default VideoMeetingCreationModal;
